import { Navigate, Outlet } from 'react-router-dom';
import { getAccountId } from '../../utils/storage';

const RequireAccount = () => {
    const accountId = getAccountId();
    if (!accountId) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default RequireAccount;
